module.exports = __webpack_public_path__ + "static/img/banner.73426a67.jpg";